export const locationList = {
  cncc: [
    {
      name: '奥林匹克公园地铁站',
      lat: '40.007933',
      lng: '116.39876'
    },
    {
      name: '国家体育馆公交站',
      lat: '40.002933',
      lng: '116.393548'
    },
    {
      name: '国家会议中心公交站',
      lat: '40.006655',
      lng: '116.393372'
    },
    {
      name: '国会服贸会VIP停车场',
      lat: '40.00527',
      lng: '116.397692'
    },
    {
      name: '国会服贸会P1停车场',
      lat: '40.005208',
      lng: '116.39532'
    },
    {
      name: '北辰西路落客点',
      lat: '40.005033',
      lng: '116.39369'
    },
    {
      name: '国家会议中心-首钢园接驳车站',
      lat: '40.006389',
      lng: '116.39528'
    },
    {
      name: '新奥购物中心地下停车场-入口',
      lat: '40.007475',
      lng: '116.40262'
    },
    {
      name: '国会服贸会P2停车场',
      lat: '40.001253',
      lng: '116.398168'
    },
    {
      name: '国会服贸会P3停车场',
      lat: '40.001087',
      lng: '116.395464'
    },
    {
      name: '天辰东路落客点',
      lat: '40.009458',
      lng: '116.397852'
    },
    {
      name: '湖景东路落客点',
      lat: '40.004943',
      lng: '116.40368'
    }
  ],
  shougang: [
    {
      name: '服贸会VIP停车场（持证）',
      lat: '39.916121',
      lng: '116.157822',
      lineLength: 'short',
      tab: 'parking'
    },
    {
      name: '服贸会P1停车场（持证）',
      lat: '39.909055',
      lng: '116.163335',
      defaultActive: true,
      tab: 'parking'
    },
    {
      name: '服贸会P2停车场（持证）',
      lat: '39.903844',
      lng: '116.172448',
      tab: 'parking'
    },
    {
      name: '服贸会P3停车场（持证）',
      lat: '39.907198',
      lng: '116.1635541',
      linePosition: 'top',
      tab: 'parking'
    },
    {
      name: '服贸会P4停车场（持证）',
      lat: '39.910139',
      lng: '116.153041',
      tab: 'parking'
    },
    {
      name: '服贸会P5停车场（持证）',
      lat: '39.913345',
      lng: '116.163615',
      tab: 'parking'
    },
    {
      name: '服贸会P6地下停车场（持证）',
      lat: '39.919350',
      lng: '116.160862',
      tab: 'parking'
    },
    {
      name: '服贸会P7A 3#馆停车场（持证）',
      lat: '39.9185651',
      lng: '116.160079',
      tab: 'parking'
    },
    {
      name: '服贸会P7B 4#馆停车场（持证）',
      lat: '39.9185652',
      lng: '116.160079',
      tab: 'parking'
    },
    {
      name: '服贸会-1号馆',
      lat: '39.916682',
      lng: '116.158745',
      tab: 'venue'
    },
    {
      name: '服贸会-2号馆一层',
      lat: '39.9180321',
      lng: '116.158191',
      tab: 'venue'
    },
    {
      name: '服贸会-2号馆二层',
      lat: '39.9180322',
      lng: '116.158192',
      tab: 'venue'
    },
    {
      name: '服贸会-3号馆',
      lat: '39.918229',
      lng: '116.159483',
      tab: 'venue'
    },
    {
      name: '服贸会-4号馆一层',
      lat: '39.9165425',
      lng: '116.1608862',
      tab: 'venue'
    },
    {
      name: '服贸会-4号馆二层',
      lat: '39.9165426',
      lng: '116.1608861',
      tab: 'venue'
    },
    {
      name: '服贸会-5号馆',
      lat: '39.915209',
      lng: '116.160710',
      tab: 'venue'
    },
    {
      name: '服贸会-6号馆',
      lat: '39.914899',
      lng: '116.161895',
      tab: 'venue'
    },
    {
      name: '服贸会-7号馆',
      lat: '39.911811',
      lng: '116.162080',
      tab: 'venue'
    },
    {
      name: '服贸会-8号馆',
      lat: '39.910629',
      lng: '116.162066',
      tab: 'venue'
    },
    {
      name: '服贸会-9号馆',
      lat: '39.911862',
      lng: '116.158757',
      tab: 'venue'
    },
    {
      name: '服贸会-10号馆',
      lat: '39.913595',
      lng: '116.158875',
      tab: 'venue'
    },
    {
      name: '服贸会-11号馆',
      lat: '39.914875',
      lng: '116.158853',
      tab: 'venue'
    },
    {
      name: '服贸会-12号馆',
      lat: '39.914704',
      lng: '116.159785',
      tab: 'venue'
    },
    // {
    //   name: '服贸会-13号馆',
    //   lat: '39.914859',
    //   lng: '116.158831',
    //   tab: 'venue'
    // },
    // {
    //   name: '服贸会-14号馆',
    //   lat: '39.914955',
    //   lng: '116.159734',
    //   tab: 'venue'
    // },
    // {
    //   name: '料仓会议室',
    //   lat: '39.916798',
    //   lng: '116.161864',
    //   tab: 'meeting'
    // },
    {
      name: '缓冲间多功能厅',
      fullName: '缓冲间多功能厅001、002',
      lat: '39.916743',
      lng: '116.162184',
      tab: 'meeting'
    },
    {
      name: '焦侧除尘多功能厅',
      fullName: '焦侧除尘多功能厅',
      lat: '39.914119',
      lng: '116.160572',
      tab: 'meeting'
    },
    {
      name: '空压机室',
      fullName: '空压机室',
      lat: '39.913796',
      lng: '116.160706',
      tab: 'meeting'
    },
    {
      name: '修理车间会议室',
      fullName: '修理车间会议室A、B、C',
      lat: '39.911588',
      lng: '116.160774',
      tab: 'meeting'
    },
    {
      name: '刀具车间会议室',
      fullName: '刀具车间会议室001、002',
      lat: '39.910819',
      lng: '116.160808',
      tab: 'meeting'
    },
    {
      name: '三高炉',
      fullName: '三高炉9.7米平台多功能厅、三高炉A馆报告厅',
      lat: '39.920469',
      lng: '116.155345',
      tab: 'meeting'
    },
    {
      name: '香格里拉酒店',
      fullName: '香格里拉酒店群明生辉宴会厅、倚山渤海同心厅',
      lat: '39.915555',
      lng: '116.149198',
      tab: 'meeting'
    },
    {
      name: '1号馆',
      fullName:
        '1号馆二层B2-1、B2-2、B2-3；铁色记忆201A、201B、201C；石景风华203；秀池风韵204；功碑春晓205',
      lat: '39.916682',
      lng: '116.158745',
      tab: 'meeting'
    },
    {
      name: '2号馆',
      fullName:
        '2号馆一层会议室西侧2-101、东侧2-102、2层会议室西侧2-201、东侧2-202',
      lat: '39.9180321',
      lng: '116.158191',
      tab: 'meeting'
    },
    {
      name: '3号馆',
      fullName:
        '3号馆2层会议室西侧3-201、东侧3-202、3层会议室西侧3-301、东侧3-302',
      lat: '39.918229',
      lng: '116.159483',
      tab: 'meeting'
    },
    {
      name: '4号馆',
      fullName:
        '4号馆2层北侧4-201、南侧4-202、3层会议室北侧4-301、南侧4-302、4层北侧4-401、南侧4-402',
      lat: '39.9165425',
      lng: '116.1608862',
      tab: 'meeting'
    },
    // {
    //   name: '3350演播厅',
    //   lat: '39.909243',
    //   lng: '116.155002',
    //   tab: 'meeting'
    // },
    // {
    //   name: '脱硫车间',
    //   lat: '39.909323',
    //   lng: '116.158329',
    //   tab: 'meeting'
    // },
    {
      name: '服贸会-1号登录厅',
      lat: '39.919292',
      lng: '116.159697',
      tab: 'lobby'
    },
    {
      name: '服贸会-2号登录厅',
      lat: '39.915796',
      lng: '116.162387',
      tab: 'lobby'
    },
    {
      name: '服贸会-3号登录厅',
      lat: '39.912929',
      lng: '116.162263',
      tab: 'lobby'
    },
    {
      name: '服贸会-4号登录厅',
      lat: '39.910188',
      lng: '116.162886',
      tab: 'lobby'
    },
    {
      name: '服贸会-5号登录厅',
      lat: '39.91012',
      lng: '116.159481',
      tab: 'lobby'
    },
    {
      name: '服贸会-6号登录厅',
      lat: '39.914616',
      lng: '116.158257',
      tab: 'lobby'
    },
    // {
    //   name: '服贸会1-6号网约车上落客点',
    //   lat: '39.91595',
    //   lng: '116.163827',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会7-9号网约车上落客点',
    //   lat: '39.913415',
    //   lng: '116.1655',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会10-12号网约车上落客点',
    //   lat: '39.90829',
    //   lng: '116.156148',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会13-15号网约车上落客点',
    //   lat: '39.915032',
    //   lng: '116.152539',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会16-18号网约车上落客点',
    //   lat: '39.917753',
    //   lng: '116.153977',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会19-21号网约车上落客点',
    //   lat: '39.921501',
    //   lng: '116.154556',
    //   tab: 'lobby'
    // },
    // {
    //   name: '服贸会摆渡车-P2停车场',
    //   lat: '39.905426',
    //   lng: '116.17296',
    //   tab: 'public'
    // },
    // {
    //   name: '服贸会摆渡车-3号登录厅',
    //   lat: '39.913117',
    //   lng: '116.164722',
    //   tab: 'public'
    // },
    // {
    //   name: '服贸会观光车-首钢焦化厂站',
    //   lat: '39.910193',
    //   lng: '116.158001',
    //   tab: 'public'
    // },
    {
      name: '服贸会观光车-秀池北站',
      lat: '39.914912',
      lng: '116.157944',
      tab: 'public'
    },
    {
      name: '服贸会观光车-首钢设备库站',
      lat: '39.914912',
      lng: '116.157945',
      tab: 'public'
    },
    {
      name: '服贸会观光车-五一剧场站',
      lat: '39.921582',
      lng: '116.15615',
      tab: 'public'
    },
    {
      name: '服贸会观光车-金安桥站',
      lat: '39.921318',
      lng: '116.161665',
      tab: 'public'
    },
    {
      name: '服贸会观光车-三高炉南广场站',
      lat: '39.919391',
      lng: '116.155307',
      tab: 'public'
    },
    {
      name: '服贸会观光车-香格里拉酒店站',
      lat: '39.915413',
      lng: '116.15018',
      tab: 'public'
    },
    {
      name: '服贸会观光车-大跳台站',
      lat: '39.910226',
      lng: '116.153361',
      tab: 'public'
    },
    {
      name: '小西门停车场',
      lat: '39.922683',
      lng: '116.149955',
      tab: 'socialParking'
    },
    {
      name: '冬奥停车楼',
      lat: '39.923377',
      lng: '116.154854',
      tab: 'socialParking'
    },
    {
      name: '秀池停车场',
      lat: '39.921292',
      lng: '116.153287',
      tab: 'socialParking'
    },
    {
      name: '金安科幻广场停车场',
      lat: '39.921742',
      lng: '116.159634',
      tab: 'socialParking'
    },
    {
      name: '冰球馆地下停车场',
      lat: '39.917515',
      lng: '116.153573',
      tab: 'socialParking'
    },
    {
      name: '金工车间停车场',
      lat: '39.917753',
      lng: '116.154341',
      tab: 'socialParking'
    },
    {
      name: '香格里拉停车场',
      lat: '39.915735',
      lng: '116.148461',
      tab: 'socialParking'
    },
    // {
    //   name: '首钢滑雪大跳台地下停车场',
    //   lat: '39.911244',
    //   lng: '116.151519',
    //   tab: 'socialParking'
    // },
    {
      name: '制氧北地面停车场',
      lat: '39.910357',
      lng: '116.153606',
      tab: 'socialParking'
    },
    {
      name: '小火车停车场',
      lat: '39.910017',
      lng: '116.151844',
      tab: 'socialParking'
    },
    {
      name: '制氧创新中心南区地上停车场',
      lat: '39.908509',
      lng: '116.156417',
      tab: 'socialParking'
    },
    {
      name: '六工汇PA楼地下',
      lat: '39.91909925',
      lng: '116.154620',
      tab: 'socialParking'
    },
    {
      name: '六工汇PB楼地下',
      lat: '39.917627',
      lng: '116.156145',
      tab: 'socialParking'
    },
    {
      name: '六工汇PD楼地下',
      lat: '39.915334',
      lng: '116.155654',
      tab: 'socialParking'
    },
    {
      name: '六工汇PE楼地下',
      lat: '39.915719',
      lng: '116.155344',
      tab: 'socialParking'
    },
    {
      name: '六工汇PF楼地下',
      lat: '39.915906',
      lng: '116.151143',
      tab: 'socialParking'
    },
    {
      name: '金安环宇荟地下停车场',
      lat: '39.922824',
      lng: '116.164874',
      tab: 'socialParking'
    },
    {
      name: '冷却塔停车场',
      lat: '39.914600',
      lng: '116.149080',
      tab: 'socialParking'
    },
    // {
    //   name: '融石广场停车场',
    //   lat: '39.917837',
    //   lng: '116.162763',
    //   tab: 'socialParking'
    // },
    {
      name: '服贸会P2停车场（可换乘摆渡车）',
      lat: '39.903844',
      lng: '116.172447',
      tab: 'socialParking',
      defaultActive: true
    },
    {
      name: '服贸会P3停车场',
      lat: '39.907198',
      lng: '116.163556',
      linePosition: 'top',
      tab: 'socialParking'
    }
  ]
}

export const exhibitionList = {
  cncc: [
    {
      no: '1',
      name: '中国服务贸易成就展',
      link: 'https://www.ciftis.org/article/91495/'
    },
    {
      no: '2',
      name: '综合展',
      link: 'https://www.ciftis.org/article/91496/'
    },
    {
      no: '3',
      name: '供应链及商务服务专题法律专区',
      link: 'https://www.ciftis.org/article/91497/'
    }
  ],
  shougang: [
    {
      no: '1',
      name: '主题展',
      link: 'https://www.ciftis.org/article/91414/'
    },
    {
      no: '2',
      name: '健康卫生服务专题展区',
      link: 'https://www.ciftis.org/article/91417/'
    },
    {
      no: '2',
      name: '运输和商务服务专题展区',
      link: 'https://www.ciftis.org/article/95230/'
    },
    {
      no: '3',
      name: '电信、计算机和信息服务专题展区',
      link: 'https://www.ciftis.org/article/91421/'
    },
    {
      no: '4',
      name: '省区市及港澳台展区',
      link: 'https://www.ciftis.org/article/91420/'
    },
    {
      no: '4',
      name: '金融服务专题展区',
      link: 'https://www.ciftis.org/article/91427/'
    },
    {
      no: '5',
      name: '环境与能源服务专题展区',
      link: 'https://www.ciftis.org/article/91416/'
    },
    {
      no: '6',
      name: '体育服务专题展区',
      link: 'https://www.ciftis.org/article/95229/'
    },
    {
      no: '7、9',
      name: '文旅服务专题展区',
      link: 'https://www.ciftis.org/article/91422/'
    },
    {
      no: '8',
      name: '教育服务专题展区',
      link: 'https://www.ciftis.org/article/95227/'
    },
    {
      no: '10',
      name: '互动体验区',
      link: 'https://www.ciftis.org/article/95227/'
    },
    {
      no: '11',
      name: '工程咨询与建筑服务专题展区',
      link: 'https://www.ciftis.org/article/91423/'
    },
    {
      no: '12',
      name: '服务消费展区',
      link: 'https://www.ciftis.org/article/91423/'
    }
  ]
}
